import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useCookies } from 'react-cookie'
import { logoutAccount } from 'src/actions'
import { deleteRefreshTokenFromCookies, getRefreshTokenFromCookies } from 'src/utils/authentication'
import { revokeTokenGQL } from 'src/services/graphql/schemas/authentication'

export const useLogout = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [, , removeCookies] = useCookies(['country_code', 'temporary_user_id'])

  const handleLogout = () => {
    removeCookies('country_code', { path: '/' })
    removeCookies('temporary_user_id', { path: '/' })
    revokeTokenGQL(getRefreshTokenFromCookies())
    deleteRefreshTokenFromCookies()
    dispatch(logoutAccount())
    navigate('/')
  }

  return { handleLogout }
}
